import React, { Component } from 'react';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import DataGrid, { RemoteOperations, Editing, Paging, Pager, Column } from 'devextreme-react/data-grid';
import { showErrorMessage } from '../utils/Utility';

const initialState = {
	pageIndex: 0,
	focusedRowKey: 0,
};

const getDataSource = props => {
	return new DataSource({
		// sort: function(e) {
		// 	alert('diego');
		// 	// CEOs are always displayed at the top
		// 	if(e.Position == "CEO")
		// 		return "!";
		// 	else
		// 		return e.Position;
		// },
		// sort: { field: "name", desc: true },
		store: new CustomStore({
			key: props.keyField,
			load: function(loadOptions) {
				try {
					var skip = loadOptions ? (typeof loadOptions.skip !== 'undefined' ? loadOptions.skip : 0) : 0;
					var take = loadOptions
						? typeof loadOptions.take !== 'undefined'
							? loadOptions.take
							: props.pageSize
						: props.pageSize;

					// console.log(`Skip ${skip}`);
					// console.log(`Take ${take}`);
					var pageIndex = Math.floor(skip / take);
					pageIndex += 1;
					// console.log('entrou');
					//  console.log(`Page Index ${pageIndex}`);

					let listData = props.fncListData(pageIndex, take);
					var result = listData.then(result => {
						return result;
					});

					// var result = props.fncListData(pageIndex, take);
					return result;
				} catch (e) {
					showErrorMessage('Ocorreu uma falha ao listar os registros.');
				}
			},

			// Option bellow is not currently supported on DataSource object

			onRemoving: function(key) {
				props.fncDeleteData(key);
			},
			remove: function() {},
		}),
	});
};

export default class DefaultGrid extends Component {
	state = { ...initialState };

	constructor(props) {
		super(props);
		this.dataSource = getDataSource(props);
	}
	reloadData() {
		this.dataSource.reload();
	}
	onEditRow = e => {
		this.props.fncGetData(e.key);
		e.cancel = true;
	};
	renderEditingProperty() {
		if (this.props.buttons) {
			return (
				<Editing
					refreshMode={'repaint'}
					mode={'row'}
					useIcons={true}
					allowUpdating={true}
					allowDeleting={true}
					allowAdding={false}
					texts={{
						confirmDeleteMessage: 'Deseja realmente excluir o registro?',
						confirmDeleteTitle: 'Confirmação',
						editRow: 'Editar',
						deleteRow: 'Excluir',
					}}
				/>
			);
		}
	}
	renderColumnButtons() {
		if (this.props.buttons) {
			return <Column width={110} type={'buttons'} buttons={this.props.buttons} />;
		}
	}
	render(props) {
		return (
			<DataGrid
				height={400}
				dataSource={this.dataSource}
				focusedRowEnabled={true}
				sort
				// defaultColumns={this.props.defaultColumns}
				showBorders={this.props.showBorders}
				onEditingStart={this.onEditRow}
				
				// sorting={'none'}
			>
				{this.renderEditingProperty()}
				{this.props.defaultColumns.map(function(columnProperty, i) {
					return (
						<Column
							key={i}
							dataField={columnProperty.dataField}
							width={columnProperty.width}
							dataType={columnProperty.dataType}
							format={columnProperty.format}
							caption={columnProperty.caption}
							calculateCellValue={columnProperty.calculateCellValue}
						/>
					);
				})}
				{this.renderColumnButtons()}
				<RemoteOperations paging={true} sorting={false} />
				<Paging defaultPageSize={this.props.pageSize} />
				<Pager infoText={'Página {0} de {1} ({2} registros)'} showNavigationButtons={true} showInfo={true} />
			</DataGrid>
		);
	}
}
